import * as svg from "../../../assets/people-icon.svg";

import {iconBuilder} from "./iconBuilder";

const PeopleIcon = iconBuilder(svg, "PeopleIcon", "0 0 21 21");

export default PeopleIcon;
